import { useRef } from "react";
import { api } from "@/lib/api";

const newToken = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random()}`);

// Google Places autocomplete session: suggestions are billed together with the one detail lookup on pick.
export function usePlaceSearch(kind) {
  const token = useRef(newToken());
  const search = async (q) => (await api.get("/au/suggest", { params: { q, kind, session: token.current } })).data;
  const resolve = async (r) => {
    if (!r.place_id) return r;
    const { data } = await api.get(`/au/place/${r.place_id}`, { params: { session: token.current } });
    token.current = newToken();
    return data;
  };
  return { search, resolve };
}

export const optionMain = (r) => r.main || r.street || (r.display || "").split(",")[0];
export const optionSub = (r) => r.secondary ?? [r.suburb, r.state, r.postcode].filter(Boolean).join(" ");
